/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-03 16:28:34
 * @LastEditTime: 2024-09-23 09:21:46
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\store\reducers\userInfo.ts
 * @Description: 
 */
import { createSlice } from '@reduxjs/toolkit';

interface DataState {
  userId: string
  loginState: boolean
  loginShow: boolean
  userInfo: any
  userList: any[]
  isPopoverVisible: boolean
}

const initialState: DataState = {
  userId: '',
  loginState: false,
  loginShow: false,
  userInfo: {},
  userList: [],
  isPopoverVisible: false
};

const dataSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUserId: (state: DataState, action) => {
      state.userId = action.payload;
    },
    setLoginShow: (state: DataState, action) => {
      state.loginShow = action.payload;
    },
    setLoginState: (state: DataState, action) => {
      state.loginState = action.payload;
    },
    setUserInfo: (state: DataState, action) => {
      state.userInfo = action.payload;
    },
    setUserList: (state: DataState, action) => {
      state.userList = action.payload;
    },
    setIsPopoverVisible: (state: DataState, action) => {
      state.isPopoverVisible = action.payload;
    }
  },
  extraReducers: (builder) => {
  }
});

export const {
  setUserId,
  setLoginState,
  setLoginShow,
  setUserInfo,
  setUserList,
  setIsPopoverVisible
} = dataSlice.actions;

export const selectUserId = (state: any) => state.userInfo?.userId;
export const selectLoginState = (state: any) => state?.userInfo?.loginState;
export const selectLoginShow = (state: any) => state?.userInfo?.loginShow;
export const selectUserInfo = (state: any) => state.userInfo?.userInfo;
export const selectUserList = (state: any) => state.userInfo?.userList;
export const selectIsPopoverVisible = (state: any) => state.userInfo?.isPopoverVisible;

export default dataSlice.reducer;
